var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicControlOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_357_13342",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_357_13342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.75 14.95L16.3 13.5C16.45 13.25 16.5793 12.9917 16.688 12.725C16.796 12.4583 16.875 12.1833 16.925 11.9C16.975 11.65 17.096 11.4373 17.288 11.262C17.4793 11.0873 17.6917 11 17.925 11C18.2417 11 18.5 11.1083 18.7 11.325C18.9 11.5417 18.975 11.7917 18.925 12.075C18.8417 12.6083 18.7 13.1123 18.5 13.587C18.3 14.0623 18.05 14.5167 17.75 14.95ZM14.8 11.95L9 6.15V5C9 4.16667 9.29166 3.45833 9.875 2.875C10.4583 2.29167 11.1667 2 12 2C12.8333 2 13.5417 2.29167 14.125 2.875C14.7083 3.45833 15 4.16667 15 5V11C15 11.1833 14.9793 11.35 14.938 11.5C14.896 11.65 14.85 11.8 14.8 11.95ZM19.1 21.9L2.1 4.9C1.91666 4.71667 1.825 4.48333 1.825 4.2C1.825 3.91667 1.91666 3.68333 2.1 3.5C2.28333 3.31667 2.51666 3.225 2.8 3.225C3.08333 3.225 3.31666 3.31667 3.5 3.5L20.5 20.5C20.6833 20.6833 20.775 20.9167 20.775 21.2C20.775 21.4833 20.6833 21.7167 20.5 21.9C20.3167 22.0833 20.0833 22.175 19.8 22.175C19.5167 22.175 19.2833 22.0833 19.1 21.9ZM11 20V17.9C9.45 17.7 8.13333 17.0583 7.05 15.975C5.96666 14.8917 5.30833 13.5917 5.075 12.075C5.025 11.7917 5.1 11.5417 5.3 11.325C5.5 11.1083 5.76666 11 6.1 11C6.33333 11 6.54166 11.0873 6.725 11.262C6.90833 11.4373 7.025 11.65 7.075 11.9C7.29166 13.0667 7.85833 14.0417 8.775 14.825C9.69166 15.6083 10.7667 16 12 16C12.5667 16 13.1043 15.9127 13.613 15.738C14.121 15.5627 14.5833 15.3167 15 15L16.425 16.425C15.9417 16.8083 15.4127 17.129 14.838 17.387C14.2627 17.6457 13.65 17.8167 13 17.9V20C13 20.2833 12.9043 20.5207 12.713 20.712C12.521 20.904 12.2833 21 12 21C11.7167 21 11.4793 20.904 11.288 20.712C11.096 20.5207 11 20.2833 11 20Z",
    fill: "#E4281B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicControlOff);
export default __webpack_public_path__ + "static/media/micControlOff.900c7124650836eb98ae7f2fa1598b6e.svg";
export { ForwardRef as ReactComponent };